/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import { EnvironmentOutline } from "antd-mobile-icons";
import { useEffect, useMemo, useState } from "react";
import { List, Popup, SpinLoading, SearchBar } from "antd-mobile-v5";
let map, localsearch, localsearchOne, localsearchTwo, localsearchThr;
const OutSideMap = ({ data, dataDefault, onChangeData, onChangeLoading }) => {
  const [addressData, setAddressData] = useState([]);
  const [addressDataOne, setAddressDataOne] = useState([]); //公司
  const [addressDataTwo, setAddressDataTwo] = useState([]); //公司
  const [addressDataThr, setAddressDataThr] = useState([]); //公司
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const showData = useMemo(() => {
    return addressData
      .concat(addressDataOne)
      .concat(addressDataTwo)
      .concat(addressDataThr);
  }, [addressDataOne, addressData, addressDataTwo, addressDataThr]);
  //解析点数据结果
  function pois(obj) {
    if (obj) {
      setAddressData(obj);
      //坐标数组，设置最佳比例尺时会用到
      var zoomArr = [];
      for (var i = 0; i < obj.length; i++) {
        //闭包
        (function (i) {
          //坐标
          var lnglatArr = obj[i].lonlat.split(",");
          var lnglat = new T.LngLat(lnglatArr[0], lnglatArr[1]);
          //创建标注对象
          var marker = new T.Marker(lnglat);
          //地图上添加标注点
          map.addOverLay(marker);

          zoomArr.push(lnglat);
        })(i);
      }
      //地图可以拖拽
      map.enableDrag();
      //显示地图的最佳级别
      map.setViewport(zoomArr);
    } else {
      setAddressData([]);
    }
  }
  function localSearchResult(result) {
    pois(result.pois);
  }
  //解析点数据结果
  function poisOne(obj) {
    if (obj) {
      setAddressDataOne(obj);
      //地图可以拖拽
      map.enableDrag();
    }
  }
  function localSearchResultOne(result) {
    poisOne(result.pois);
  }
  //解析点数据结果
  function poisTwo(obj) {
    if (obj) {
      setAddressDataTwo(obj);
      //地图可以拖拽
      map.enableDrag();
    }
  }
  function localSearchResultTwo(result) {
    poisTwo(result.pois);
  }
  //解析点数据结果
  function poisThr(obj) {
    if (obj) {
      setAddressDataThr(obj);
      //地图可以拖拽
      map.enableDrag();
    }
  }
  function localSearchResultThr(result) {
    poisThr(result.pois);
  }
  function onLoad(lng, lat) {
    setLoading(true);
    onChangeLoading(true);
    const mapId = document.getElementById("myMap");
    if (mapId) {
      map = new T.Map("myMap", {
        projection: "EPSG:4326",
      });

      map.centerAndZoom(new T.LngLat(lng, lat), 18);
      // 定义该矩形的显示区域
      //创建标注对象
      var marker = new T.Marker(new T.LngLat(lng, lat));
      //向地图上添加标注
      map.clearOverLays();
      map.addOverLay(marker);
      var config = {
        pageCapacity: 10, //每页显示的数量
        onSearchComplete: localSearchResult, //接收数据的回调函数
      };
      var configOne = {
        pageCapacity: 10, //每页显示的数量
        onSearchComplete: localSearchResultOne, //接收数据的回调函数
      };
      var configTwo = {
        pageCapacity: 10, //每页显示的数量
        onSearchComplete: localSearchResultTwo, //接收数据的回调函数
      };
      var configThr = {
        pageCapacity: 10, //每页显示的数量
        onSearchComplete: localSearchResultThr, //接收数据的回调函数
      };
      //创建搜索对象

      localsearch = new T.LocalSearch(map, config);

      localsearchOne = new T.LocalSearch(map, configOne);
      localsearchOne.searchNearby("公司", new T.LngLat(lng, lat), 100);
      localsearchTwo = new T.LocalSearch(map, configTwo);
      localsearchTwo.searchNearby("小区", new T.LngLat(lng, lat), 100);
      localsearchThr = new T.LocalSearch(map, configThr);
      localsearchThr.searchNearby("大厦", new T.LngLat(lng, lat), 100);
      //地图可以拖拽
      map.enableDrag();
      setLoading(false);
      onChangeLoading(false);
    } else {
      setLoading(false);
      onChangeLoading(false);
    }
  }
  useEffect(() => {
    if (data?.mLong) {
      onLoad(data?.mLong, data?.mLati);
    }
  }, []);
  return (
    <>
      {loading ? (
        <div
          style={{
            height: 242,
            lineHeight: "242px",
            marginLeft: "calc(50% - 24px)",
          }}
        >
          <SpinLoading color="primary" />
        </div>
      ) : (
        <>
          <div id="myMap" style={{ height: 242 }}></div>
          <div style={{ padding: "12px 16px" }}>
            <div
              style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
            >
              <EnvironmentOutline />
              <div style={{ fontWeight: 500, fontSize: 16, marginLeft: 8 }}>
                {data?.main}
              </div>
            </div>
            <div
              onClick={() => {
                setVisible(true);
              }}
            >
              <div style={{ color: "#666" }}>{data?.detail}</div>
              <div style={{ color: "#2367FB", marginTop: 6 }}>更换地点</div>
            </div>
          </div>
        </>
      )}
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        onClose={() => {
          setVisible(false);
        }}
        bodyStyle={{ height: "44vh", overflow: "auto" }}
      >
        <div>
          <div style={{ padding: "7px 6px", background: "#fff" }}>
            <SearchBar
              placeholder="请输入内容"
              onChange={(value) => {
                // localsearch.search(value);
                localsearch.searchNearby(
                  value,
                  new T.LngLat(dataDefault?.mLong, dataDefault?.mLati),
                  100
                );
              }}
            />
          </div>
          <List>
            {showData.map((item, index) => (
              <List.Item
                onClick={() => {
                  const a = item.lonlat.split(",")[0];
                  const b = item.lonlat.split(",")[1];
                  onChangeData(a, b);
                }}
                key={index}
                prefix={null}
                description={item?.address || "无"}
              >
                {item?.name}
              </List.Item>
            ))}
          </List>
        </div>
      </Popup>
    </>
  );
};
export default OutSideMap;
